module.exports = __webpack_public_path__ + "img/Denmark.00068a51.png";